export enum PermissionStates {
  GRANTED = 'granted',
  DENIED = 'denied',
  PROMPT = 'prompt',
  PROMPT_WITH_RATIONALE = 'prompt-with-rationale'
}
